define('bindingHandlers/fixedVerticalNavigation',[
    'jquery',
    'lib/lodash4',
    'lib/knockout'
], function ($, _, ko) {

    'use strict';

    /**
     * This binding handler allows for a list-group to be
     * the height of the viewport.
     *
     * Note: as of 10/28/14 the primary use case is for the
     * queue management page. This could be expanded for other
     * uses as they arise.
     */
    ko.bindingHandlers.fixedVerticalNavigation = {

        init: function(element) {

            var $element = $(element);
            var heightOfViewport;
            var OFFSET = 300;
            var $window = $(window);
            var uniqueID = _.uniqueId();
            var eventNamespace = 'resize.' + uniqueID;

            var setHeight = function() {
                heightOfViewport = $window.height();
                $element.height(heightOfViewport - OFFSET);
            };

            setHeight();

            $window.on(eventNamespace, setHeight);

            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {

                $window.off(eventNamespace, setHeight);

            });

        }



    };

});

